import { PageMap } from '@wix/wixstores-client-core';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import type { IThankYouPageInfo } from '../types';

function thankYouPageInfoToQueryParams(thankYouPageInfo: IThankYouPageInfo): {
  id: string;
  objectType: string;
  continueShoppingUrl?: string;
} {
  if (!(thankYouPageInfo.orderId || thankYouPageInfo.subscriptionId)) {
    throw Error('Cannot navigate without relevant Id');
  }
  if (thankYouPageInfo.orderId && thankYouPageInfo.subscriptionId) {
    throw Error('Cannot navigate with both order Id and subscription Id');
  }

  return {
    id: thankYouPageInfo.orderId
      ? thankYouPageInfo.orderId
      : thankYouPageInfo.subscriptionId!,
    objectType: thankYouPageInfo.subscriptionId ? 'subscription' : '',
    ...(thankYouPageInfo.continueShoppingUrl
      ? { continueShoppingUrl: thankYouPageInfo.continueShoppingUrl }
      : {}),
  };
}

export const toThankYouPage =
  ({
    context,
    origin,
  }: {
    context: EcomPlatformViewerScriptContext;
    origin: string;
  }) =>
  async (args: IThankYouPageInfo): Promise<void> => {
    const thankYouPageQueryParams = thankYouPageInfoToQueryParams(args);
    await context.siteStore.navigate(
      {
        sectionId: PageMap.THANKYOU,
        state: thankYouPageQueryParams.id,
        queryParams: {
          origin,
          objectType: thankYouPageQueryParams.objectType,
          ...(thankYouPageQueryParams.continueShoppingUrl
            ? {
                continueShoppingUrl:
                  thankYouPageQueryParams.continueShoppingUrl,
              }
            : {}),
        },
      },
      true,
    );
  };
